import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Select from "react-select";

import {
  showNotificationWithTimeout,
  saveLaborRule,
} from "../../../Redux/actions";
import ErrorContainer from "../../Components/ErrorContainer";
import ModelContainer from "../../Components/ModelContainer";
import { checkNull } from "../../../helpers";

const schema = yup
  .object({
    id: yup.string(),
    rule_name: yup.string().required(),
    meal_allowance_type_id: yup.string().required(),
    employment_status_id: yup.string().required(),
    employee_function_id: yup.string().required(),
    employee_category_id: yup.string().required(),
    employee_category: yup.string().when("employee_category_id", {
      is: "1",
      then: yup.string().required(),
    }),
    employee_select: yup.array().required().min(1),
    value: yup.number().positive().required(),
    min_unpaid_mid_shift: yup.string().when("meal_allowance_type_id", {
      is: "3",
      then: yup.string().required(),
    }),
    min_daily_hours_worked: yup.string().when("meal_allowance_type_id", {
      is: "2",
      then: yup.string().required(),
    }),
  })
  .required();
const AllowanceRule = ({ openDeleteRuleModal }) => {
  const dispatch = useDispatch();
  const {
    account,
    mealAllowanceTypes,
    employmentStatuses,
    employeeFunctions,
    emp_category,
    employees,
    daily_hours,
    split_hours,
    allowance_rules,
  } = useSelector((state) => state.authReducer.setup_wizard_details);
  const labor_setting_essentials = useSelector((state) => state.authReducer);
  const initialForm = {
    id: "",
    rule_name: "",
    meal_allowance_type_id: "",
    employment_status_id: "",
    employee_function_id: "",
    employee_category_id: "",
    employee_category: "",
    employee_select: [],
    value: "",
    min_unpaid_mid_shift: "",
    min_daily_hours_worked: "",
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [ruleModal, setRuleModal] = useState(false);
  const [templateModal, setTemplateModal] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [empsArr, setEmpsArr] = useState([]);
  const [inputForm, setInputForm] = useState(initialForm);

  const changeInputHandler = (input, val) => {
    // if (input == "meal_allowance_type_id") {
    //   dispatch(getAccrualTypes(val));
    // }

    // employee all selected option
    if (
      input == "employee_select" &&
      val.length > 0 &&
      val.findIndex((p) => p.value == "all") > -1
    ) {
      val = addEmpToArray(true);
    } else if (
      input == "employee_select" &&
      inputForm?.employee_select?.length > 0 &&
      inputForm?.employee_select.findIndex((p) => p.value == "all") > -1 &&
      val.findIndex((p) => p.value == "all") == -1
    ) {
      val = [];
    }
    // employee all selected option END

    setValue(input, val);
    setInputForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const initialModalState = () => {
    setInputForm(initialForm);
    reset(initialForm);
  };

  const closeModal = useCallback(
    (value) => {
      setRuleModal(value);
      initialModalState();
    },
    [ruleModal]
  );

  const closeTemplateModal = useCallback(
    (value) => {
      setTemplateModal(value);
    },
    [ruleModal]
  );

  const addEmpToArray = (isDisable = false) => {
    let newEmpArr = [];
    Object.keys(employees).map((emp) => {
      const newEmpObj = { value: emp, label: employees[emp] };
      if (emp !== "all" && isDisable) {
        newEmpObj.isDisabled = true;
      }
      newEmpArr.push(newEmpObj);
    });
    return newEmpArr;
  };

  useEffect(() => {
    if (employees && employees !== null) {
      setEmpsArr(addEmpToArray());
    }
  }, [employees]);

  const editRuleHandler = (editRule, isTemplate = false) => {
    if (isTemplate) closeTemplateModal(false);
    closeModal(true);
    const editValues = {
      id: isTemplate ? "" : checkNull(editRule?.id),
      rule_name: isTemplate ? "" : checkNull(editRule?.rule_name),
      meal_allowance_type_id: checkNull(editRule?.meal_allowance_type_id),
      employment_status_id: checkNull(editRule?.employment_status_id),
      employee_function_id: checkNull(editRule?.employee_function_id),
      employee_category_id: checkNull(editRule?.employee_category_id),
      employee_category: "",
      employee_select: [],
      value: checkNull(editRule?.value),
      min_unpaid_mid_shift: checkNull(editRule?.min_unpaid_mid_shift),
      min_daily_hours_worked: checkNull(editRule?.min_daily_hours_worked),
    };
    if (
      editRule?.employee_select &&
      checkNull(editRule?.employee_select, false)
    ) {
      let newEmpArr = [];
      if (editRule?.employee_select.split(",").length > 0) {
        editRule?.employee_select.split(",").map((emp) => {
          if (employees?.[emp]) {
            newEmpArr.push({ value: emp, label: employees[emp] });
          }
        });
      }
      editValues.employee_select = newEmpArr;
    }
    setInputForm(editValues);
    reset(editValues);
  };

  const templateSubmitHandler = () => {
    if (
      templateId &&
      allowance_rules &&
      allowance_rules.length > 0 &&
      allowance_rules.findIndex((p) => p.id == templateId) > -1
    ) {
      const templateIndex = allowance_rules.findIndex(
        (p) => p.id == templateId
      );
      editRuleHandler(allowance_rules?.[templateIndex], true);
    } else {
      dispatch(
        showNotificationWithTimeout("Please select valid template!", "error")
      );
    }
  };

  const submitForm = (data) => {
    data.employee_select = data.employee_select.map((emp) => emp.value);
    console.log("submitForm", data);
    dispatch(saveLaborRule(data, "meal"));
    closeModal(false);
  };

  return (
    <>
      <h4 className="sm-hd light mt-5"> Allowance Rules </h4>

      <div class="table-responsive inner-space screen-scroll">
        <table class="table checklist-table remove-space inventory_table">
          <thead>
            <tr>
              <th> Rule Name &amp; Type </th>
              <th>Employment Status</th>
              <th>Function</th>
              <th>Category</th>
              <th>Employee Name</th>
              <th>Value</th>
              <th>Minimum Time</th>
              <th className="action-td">Actions</th>
            </tr>
          </thead>
          <tbody>
            {allowance_rules &&
              allowance_rules.length > 0 &&
              allowance_rules.map((rule) => {
                return (
                  <tr>
                    <td>
                      <b>{rule?.rule_name}</b> <br />{" "}
                      {rule?.meal_allowance_type?.name}
                    </td>
                    <td>
                      {rule?.employment_status_id == "all"
                        ? "All"
                        : rule?.employment_status?.name ?? "-"}
                    </td>
                    <td>
                      {" "}
                      {rule?.employee_function_id == "all"
                        ? "All"
                        : rule?.employee_function?.name ?? "-"}{" "}
                    </td>
                    <td>
                      {" "}
                      {rule?.employee_category_id == "all"
                        ? "All"
                        : rule?.employee_category?.name ?? "-"}{" "}
                    </td>
                    <td> {rule?.employee_select ?? "-"} </td>
                    <td> {rule?.value} </td>
                    <td>
                      {" "}
                      {rule?.meal_allowance_type_id == 2
                        ? `${rule?.min_daily_hours_worked} hrs`
                        : rule?.meal_allowance_type_id == 3
                        ? `${rule?.min_unpaid_mid_shift}`
                        : ""}{" "}
                    </td>
                    <td class="action-td">
                      <div class="d-flex">
                        {rule?.parent_id == 0 && (
                          <>
                            <a
                              className="open_lcr_edit circle_icon"
                              onClick={() => editRuleHandler(rule)}
                            >
                              <i className="iconSprites edit-icon"></i>
                            </a>
                            <a
                              className="deleterulesleave circle_icon red"
                              onClick={() =>
                                openDeleteRuleModal({
                                  id: rule?.id,
                                  rule: "meal",
                                })
                              }
                            >
                              <i className="iconSprites delete-icon"></i>
                            </a>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="my-3">
        <a
          id=""
          class="btn green-btn-revert add-plus open_lcr "
          onClick={() => closeModal(true)}
        >
          <i class="i-icon"> </i> Add Rule{" "}
        </a>
        <a
          id=""
          onClick={() => closeTemplateModal(true)}
          class="btn bordered-btn open_lcr_template "
        >
          {" "}
          Add From Template{" "}
        </a>
      </div>
      <ModelContainer
        title={`${inputForm?.id !== "" ? "Edit" : "Add"} Allowance Rules`}
        open={ruleModal}
        closeModal={closeModal}
        submitModal={handleSubmit(submitForm)}
        is_loading={false}
      >
        <form>
          {console.log("Errors", errors)}
          {console.log("inputForm", inputForm)}
          <div className="form-list popup-modal">
            <ul className="px-0">
              <li>
                <label className="required"> Rule Name </label>
                <div className="input-group mb10">
                  <input
                    {...register("rule_name")}
                    className="required"
                    placeholder="Rule Name"
                    type="text"
                    onChange={(event) =>
                      changeInputHandler("rule_name", event?.target?.value)
                    }
                    value={inputForm?.rule_name}
                  />
                  <ErrorContainer errors={errors} name="rule_name" />
                </div>
              </li>
              <li>
                <label className="required"> Type </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("meal_allowance_type_id")}
                    name="meal_allowance_type_id"
                    className="required changing"
                    onChange={(event) =>
                      changeInputHandler(
                        "meal_allowance_type_id",
                        event?.target?.value
                      )
                    }
                    disabled={inputForm?.id !== ""}
                    value={inputForm?.meal_allowance_type_id}
                  >
                    <option value=""> Select Type </option>
                    {mealAllowanceTypes &&
                      mealAllowanceTypes !== null > 0 &&
                      Object.keys(mealAllowanceTypes).map((index) => {
                        return (
                          <option value={index} key={index}>
                            {" "}
                            {mealAllowanceTypes?.[index]}{" "}
                          </option>
                        );
                      })}
                  </select>
                  <ErrorContainer
                    errors={errors}
                    name="meal_allowance_type_id"
                  />
                </div>
              </li>
              <li>
                <label className="required"> Employee Status </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("employment_status_id")}
                    name="employment_status_id"
                    className="required changing"
                    onChange={(event) =>
                      changeInputHandler(
                        "employment_status_id",
                        event?.target?.value
                      )
                    }
                    disabled={inputForm?.id !== ""}
                    value={inputForm?.employment_status_id}
                  >
                    <option value=""> Select Employment Status </option>
                    {employmentStatuses &&
                      employmentStatuses !== null > 0 &&
                      Object.keys(employmentStatuses).map((index) => {
                        return (
                          <option value={index} key={index}>
                            {" "}
                            {employmentStatuses?.[index]}{" "}
                          </option>
                        );
                      })}
                  </select>
                  <ErrorContainer errors={errors} name="employment_status_id" />
                </div>
              </li>
              <li>
                <label className="required"> Employee Function </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("employee_function_id")}
                    name="employee_function_id"
                    className="required changing"
                    onChange={(event) =>
                      changeInputHandler(
                        "employee_function_id",
                        event?.target?.value
                      )
                    }
                    disabled={inputForm?.id !== ""}
                    value={inputForm?.employee_function_id}
                  >
                    <option value=""> Select Employee Function </option>
                    {employeeFunctions &&
                      employeeFunctions !== null > 0 &&
                      Object.keys(employeeFunctions).map((index) => {
                        return (
                          <option value={index} key={index}>
                            {" "}
                            {employeeFunctions?.[index]}{" "}
                          </option>
                        );
                      })}
                  </select>
                  <ErrorContainer errors={errors} name="employee_function_id" />
                </div>
              </li>
              <li>
                <label className="required"> Employee Category </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("employee_category_id")}
                    name="employee_category_id"
                    className="required changing"
                    onChange={(event) =>
                      changeInputHandler(
                        "employee_category_id",
                        event?.target?.value
                      )
                    }
                    disabled={inputForm?.id !== ""}
                    value={inputForm?.employee_category_id}
                  >
                    <option value=""> Select Employee Category </option>
                    {emp_category &&
                      emp_category !== null > 0 &&
                      Object.keys(emp_category).map((index) => {
                        return (
                          <option value={index} key={index}>
                            {" "}
                            {emp_category?.[index]}{" "}
                          </option>
                        );
                      })}
                  </select>
                  <ErrorContainer errors={errors} name="employee_category_id" />
                </div>
              </li>
              {inputForm?.employee_category_id == 1 && (
                <li>
                  <label className="required"> Employee Category </label>
                  <div className="input-group mb10">
                    <input
                      {...register("employee_category")}
                      className="required"
                      type="text"
                      onChange={(event) =>
                        changeInputHandler(
                          "employee_category",
                          event?.target?.value
                        )
                      }
                      value={inputForm?.employee_category}
                    />
                    <ErrorContainer errors={errors} name="employee_category" />
                  </div>
                </li>
              )}

              <li>
                <label className="required"> Employee Select </label>
                <div className="px-0">
                  <Select
                    className="w-100"
                    {...register("employee_select")}
                    value={inputForm?.employee_select}
                    onChange={(values) =>
                      changeInputHandler("employee_select", values)
                    }
                    options={empsArr}
                    isMulti
                    isDisabled={inputForm?.id !== ""}
                  />
                  <ErrorContainer errors={errors} name="employee_select" />
                </div>
              </li>
              <li>
                <label className="required"> Default Allowance Amount </label>
                <div className="input-group mb10">
                  <input
                    {...register("value")}
                    className="required"
                    placeholder="Value"
                    type="text"
                    onChange={(event) =>
                      changeInputHandler("value", event?.target?.value)
                    }
                    value={inputForm?.value}
                  />
                  <ErrorContainer errors={errors} name="value" />
                </div>
              </li>
              {inputForm?.meal_allowance_type_id == 3 && (
                <li>
                  <label className="required">
                    {" "}
                    Minimum Unpaid Mid Shift Period{" "}
                  </label>
                  <div className="input-wrap select-div">
                    <select
                      {...register("min_unpaid_mid_shift")}
                      name="min_unpaid_mid_shift"
                      className="required changing"
                      onChange={(event) =>
                        changeInputHandler(
                          "min_unpaid_mid_shift",
                          event?.target?.value
                        )
                      }
                      value={inputForm?.min_unpaid_mid_shift}
                    >
                      <option value=""> Select </option>
                      {split_hours &&
                        split_hours !== null > 0 &&
                        Object.keys(split_hours).map((index) => {
                          return (
                            <option value={index} key={index}>
                              {" "}
                              {split_hours?.[index]}{" "}
                            </option>
                          );
                        })}
                    </select>
                    <ErrorContainer
                      errors={errors}
                      name="min_unpaid_mid_shift"
                    />
                  </div>
                </li>
              )}

              {inputForm?.meal_allowance_type_id == 2 && (
                <li>
                  <label className="required">
                    {" "}
                    Minimum Daily Hours Worked{" "}
                  </label>
                  <div className="input-wrap select-div">
                    <select
                      {...register("min_daily_hours_worked")}
                      name="min_daily_hours_worked"
                      className="required changing"
                      onChange={(event) =>
                        changeInputHandler(
                          "min_daily_hours_worked",
                          event?.target?.value
                        )
                      }
                      value={inputForm?.min_daily_hours_worked}
                    >
                      <option value=""> Select </option>
                      {daily_hours &&
                        daily_hours !== null > 0 &&
                        Object.keys(daily_hours).map((index) => {
                          return (
                            <option value={index} key={index}>
                              {" "}
                              {daily_hours?.[index]}{" "}
                            </option>
                          );
                        })}
                    </select>
                    <ErrorContainer
                      errors={errors}
                      name="min_daily_hours_worked"
                    />
                  </div>
                </li>
              )}
            </ul>
          </div>
        </form>
      </ModelContainer>
      {/* From Template section */}
      <ModelContainer
        title={`"Add Leave/Claim Rules`}
        open={templateModal}
        closeModal={closeTemplateModal}
        submitModal={templateSubmitHandler}
        is_loading={false}
      >
        <form>
          <div className="form-list popup-modal">
            <ul className="px-0">
              <li>
                <label className="required"> Select Templates </label>
                <div className="input-wrap select-div">
                  <select
                    name="template_id"
                    className="required changing"
                    onChange={(event) => setTemplateId(event?.target?.value)}
                    value={templateId}
                  >
                    <option value=""> Select </option>
                    {allowance_rules &&
                      allowance_rules.length > 0 &&
                      allowance_rules.map((leave) => {
                        return (
                          <option value={leave?.id} key={leave?.id}>
                            {leave?.rule_name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </li>
            </ul>
          </div>
        </form>
      </ModelContainer>
      {/* From Template section END */}
    </>
  );
};
export default AllowanceRule;
